import { AbstractControl, ValidationErrors } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

export function institutionSuffix(institutionSuffixes: BehaviorSubject<string[]>) {
    return (control: AbstractControl): ValidationErrors | null => {
        const email = control?.value as string;
        const suffixes = institutionSuffixes.getValue();
        const notSuffix = suffixes?.length && !suffixes.some(suffix => email?.endsWith(suffix));
        return notSuffix ? { institutionSuffix: 'research.apc.form.inst.email.error' } : null;
    };
}
